import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsDepartment from 'graphql/fields/FieldsDepartment'

const fields = {
	'guid': 'String',
	'name': 'String!',
	'company_guid': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation department( ${ HelperGraphql.createFields( fields ) } ) {
	    department( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsDepartment}
	    }
	}
`);

